import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import Address from 'components/shared//Helpers/Address'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button, Header, Segment } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { contactRequests } = state.contactRequests
  return { contactRequests }
}

const mapDispatchToProps = () => {
  return {}
}

class ContactRequestDetails extends React.Component {
  render() {
    const dark = config.theme.dark
    const {
      match: {
        params: { contact_request_id },
      },
    } = this.props // withRouter
    const { contactRequests = [] } = this.props // redux
    const contactRequest = contactRequests.find(
      (contactRequest) => contactRequest.id === Number(contact_request_id)
    )
    const mailSubject = I18n.t('admin.contact_requests.details.mail_subject', {
      customer: config.navigation.customerName,
    })
    const message =
      contactRequest &&
      contactRequest.message &&
      contactRequest.message.split('\n').map((line, index) => (
        <span key={index}>
          {line}
          <br />
        </span>
      ))

    return !contactRequest ? (
      <ComponentPlaceholder inactive loading={false} />
    ) : (
      <div
        className={classNames([
          'contactRequestDetails',
          contactRequest.id ? 'active-window' : 'inactive-window',
          dark && 'inverted',
        ])}>
        <ComponentHeader
          title={
            new Date(contactRequest.created_at).toLocaleString() +
            ' - ' +
            contactRequest.company
          }
          customActions={[
            <Button
              primary
              href={`mailto:${
                contactRequest.email
              }?subject=${mailSubject}&body=${contactRequest.message}`}
              content={'Reply'}
              icon="send"
              fluid
            />,
          ]}
        />

        <Segment attached className={classNames([dark && 'inverted'])}>
          <Address data={contactRequest} noLinks />
        </Segment>

        <Segment attached className={classNames([dark && 'inverted'])}>
          <Header
            as="h3"
            dividing
            content={I18n.t('admin.contact_requests.details.mail')}
          />
          <p children={message} />
        </Segment>
      </div>
    )
  }
}

ContactRequestDetails = connect(mapStateToProps, mapDispatchToProps)(
  ContactRequestDetails
)
export default withRouter(ContactRequestDetails)



// WEBPACK FOOTER //
// ./src/components/admin/ContactRequests/ContactRequestDetails.jsx